exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dynamic-sidebar {\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  padding-top: 35px;\n  background: white;\n  overflow: hidden;\n  -webkit-box-sizing: border-box;\n  /* Safari/Chrome, other WebKit */\n  /* Firefox, other Gecko */\n  box-sizing: border-box;\n  -webkit-box-shadow: -5px 0 5px -2px #888;\n  box-shadow: -5px 0 5px -2px #888; }\n  .dynamic-sidebar .dynamic-sidebar-close-button {\n    position: relative;\n    z-index: 1001;\n    text-align: right; }\n  .dynamic-sidebar .dynamic-sidebar-content {\n    position: relative;\n    z-index: 1001;\n    max-height: calc(100% - 15px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-box-sizing: border-box;\n    /* Safari/Chrome, other WebKit */\n    /* Firefox, other Gecko */\n    box-sizing: border-box; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/shared/components/dynamic-component/dynamic-component.component.scss
// module id = ../../../../../src/app/shared/components/dynamic-component/dynamic-component.component.scss
// module chunks = main